const zh_CN = {
    'tabs.header.message': "消息中心",
    'tabs.header.task':"任务中心",
}
export default zh_CN;


// WEBPACK FOOTER //
// ./src/components/Intl/locales/zh.js